module.exports = {
	"error.status": "Error",
	"error.validation.error": "Validation error",
	"error.deployment.error": "Deployment error",
	"error.required.fields.missing": "Enter all required fields.",
	"error.form": "Form contains errors.",
	"error.title": "Unable to carry out the operation. No updates have been made. See details below.",
	"error.api.file.invalid.json.swagger": "Swagger file has invalid JSON.",
	"error.api.field.unique.name": "API Name must be unique.",
	"error.api.field.unique.proxyUrl": "API URI must be unique.",
	"error.applications.update": "Unable to carry out the operation. No updates have been made. See details below.",
	"error.gateway.bundle.fetch": "Request failed. Unable to fetch Gateway Bundle list.",
	"error.gateway.bundle.delete": "There was an error deleting this Gateway Bundle.",
	"error.gateway.bundle.undeploy": "Error undeploying the Gateway Bundle.",
	"error.gateway.bundle.file.name.unique": "Unable to upload the file. File name must be unique.",
	"error.gateway.bundle.file.count": "Only 3 files can be upload.",
	"error.gateway.bundle.file.size": "Required files: Metadata yml file, Gateway Bundle, Delete Bundle. Maximum size per file is 15 MB.",
	"error.gateway.bundle.file.metadata.yml.count": "Only one yml file can be uploaded.",
	"error.gateway.bundle.file.bundle.count": "Only one bundle file can be upload.",
	"error.gateway.bundle.file.delete.bundle.count": "Only one delete bundle file can be upload.",
	"error.gateway.bundle.proxy.list.fetch": "Request failed. Unable to fetch Gateway Bundle deployments proxy list.",
	"error.organization.list.fetch": "Request failed. Unable to fetch Organizations list.",
	"error.organization.form.load": "Request failed. Unable to populate the form.",
	"error.organization.form.validation": "Request failed. Unable to validate the form.",
	"error.organization.form.submit.create": "Request failed. Failed to create the organization",
	"error.organization.form.submit.update": "Request failed. Failed to update the organization",
	"error.user.fetch": "Request failed. Unable to fetch User list.",
	"error.proxy.delete": "There was an error deleting this Proxy.",
	"warning.status": "Warning",
	"label.dialog.unsaved.changes.title": "Unsaved Changes",
	"label.dialog.unsaved.changes.description": "Your changes will be lost if you leave this page. Are you sure you want to continue away from this page?",
	"label.dialog.unsaved.changes.submit": "Continue",
	"label.dialog.unsaved.changes.cancel": "Stay",
	"label.dialog.unsaved.changes.exit": "Exit",
	"label.filter": "Filter",
	"label.filter.by": "Filter By",
	"label.sort": "Sort",
	"label.sort.by": "Sort By",
	"label.sort.by.name.asc": "Name: A-Z",
	"label.sort.by.name.desc": "Name: Z-A",
	"label.sort.by.api.name.asc": "API Name: A-Z",
	"label.sort.by.api.name.desc": "API Name: Z-A",
	"label.sort.by.date.created.asc": "Date Created: Old to New",
	"label.sort.by.date.created.desc": "Date Created: New to Old",
	"label.sort.by.date.updated.asc": "Date Updated: Old to New",
	"label.sort.by.date.updated.desc": "Date Updated: New to Old",
	"label.sort.by.status.asc": "Status: A-Z",
	"label.sort.by.status.desc": "Status: Z-A",
	"label.pagination.prev": "Previous",
	"label.pagination.next": "Next",
	"label.pagination.rows.per.page": "Rows per page",
	"label.pagination.items.per.page": "Items per page",
	"label.name": "Name",
	"label.username": "Username",
	"label.email": "Email",
	"label.status": "Status",
	"label.role": "Role",
	"label.roles": "Roles",
	"label.group": "Group",
	"label.policyTemplate": "Policy Template",
	"label.version": "Version",
	"label.update.to.version": "Update to version",
	"label.type": "Type",
	"label.metadata": "Metadata",
	"label.description": "Description",
	"label.assets": "Assets",
	"label.assets.help": "This metadata file contains environment dependency information.",
	"label.download": "Download",
	"label.deploy": "Deploy",
	"label.details": "Details",
	"label.redeploy": "Redeploy",
	"label.undeploy": "Undeploy",
	"label.more.info": "More Info",
	"label.check.now": "Check now",
	"label.updating": "Updating...",
	"label.update": "Update",
	"label.validating": "Validating...",
	"label.not.applicable": "N/A",
	"label.information": "Information",
	"label.last.updated": "Last Updated",
	"label.updating.status.check.in": "Updating status: check in",
	"label.update.in": "Update in",
	"label.unit.seconds": "s",
	"label.actions.button": "Actions",
	"label.ok.button": "OK",
	"label.next.button": "Next",
	"label.save.button": "Save",
	"label.save.and.next.button": "Save & Next",
	"label.cancel.button": "Cancel",
	"label.copy.button": "Copy",
	"label.close.button": "Close",
	"label.copy.close.button": "Copy & Close",
	"label.exit.button": "Exit",
	"label.go.to": "Go To",
	"label.go": "Go",
	"label.delete.button": "Delete",
	"label.delete.confirmation.title": "Confirm Delete",
	"label.delete.confirmation.text": "This action cannot be undone.",
	"label.action.confirmation.text": "Are you sure you want to perform this action?",
	"label.no.results": "No results",
	"label.deployments.filter.by.name.placeholder": "Proxy Name",
	"label.deployments.state.all": "All Deployment Status",
	"label.deployments.state.any": "Any Deployment Status",
	"label.deployments.state.deployed": "Deployed",
	"label.deployments.state.not.deployed": "Not Deployed",
	"label.deployments.state.pending.deployment": "Pending Deployment",
	"label.deployments.state.pending.undeployment": "Pending Undeployment",
	"label.deployments.state.error.undeploy": "Error Undeploy",
	"label.deployments.state.error": "Error",
	"label.api.key.delete.confirmation.text": "Key will be removed immediately and all application access via this key will be lost. This cannot be undone. To temporarily revoke access consider disabling the key instead.",
	"label.api.key.delete.button": "Delete Key",
	"label.api.key.delete.loading.title": "Deleting Key",
	"label.api.key.delete.loading.text": "Undeploying and deleting key. This may take several minutes.",
	"label.account.plans": "Account Plans",
	"label.apis": "APIs",
	"label.api.plans": "API Plans",
	"label.application.api.keys": "Application API Keys",
	"label.gateway.bundles": "Gateway Bundles",
	"label.gateway.bundle.no.results": "You have no Gateway Bundles.",
	"label.gateway.bundle.filter.no.results": "There are no Gateway Bundles to match your criteria.",
	"label.gateway.bundle.use.add.button.help": "Use the Add Bundle button to upload your files.",
	"label.gateway.bundle.list.page.title": "Gateway Bundles",
	"label.gateway.bundle.list.page.title.help": "Any Gateway code, configuration, or environment can be exported as a Gateway Bundle from Policy Plugin. It can be managed and deployed to proxies in Portal.",
	"label.gateway.bundle.list.page.filter.by.name.placeholder": "Gateway Bundle Name",
	"label.gateway.bundle.list.page.filter.by.group.placeholder": "Group",
	"label.gateway.bundle.list.page.sort.by.date.created.asc": "Date Created: Old to New",
	"label.gateway.bundle.list.page.sort.by.date.created.desc": "Date Created: New to Old",
	"label.gateway.bundle.api.page.sort.by.date.modified.asc": "Date Modified: Old to New",
	"label.gateway.bundle.api.page.sort.by.date.modified.desc": "Date Modified: New to Old",
	"label.gateway.bundle.add.button": "Add Bundle",
	"label.gateway.bundle.date.created": "Date Created ({zone})",
	"label.gateway.bundle.details.page.title": "GATEWAY BUNDLE DETAILS",
	"label.gateway.bundle.details.page.metadata.title": "Metadata",
	"label.gateway.bundle.details.l7Template": "Policy Template",
	"label.gateway.bundle.details.l7Template.tooltip": "Contains encapsulated assertions that are reusable through API assignment.",
	"label.gateway.bundle.details.apis.tooltip": "Number of Apis that are using the policy template from this bundle",
	"label.gateway.bundle.details.page.deployments.title": "Gateway Bundle Deployments",
	"label.gateway.bundle.details.page.api.title": "APIs",
	"label.gateway.bundle.actions.delete.disabled.tooltip": "Cannot delete a Gateway Bundle. The bundle is deployed on one or more proxies or referred in one or more APIs. Undeploy the bundle from all proxies or remove the policy template of the bundle from the API(s).",
	"label.gateway.bundle.file.uploader": "Click to upload or drag files here",
	"label.gateway.bundle.file.help": "Required files: Metadata yml file, Gateway Bundle, Delete Bundle. Maximum size per file is 15 MB.",
	"label.gateway.bundle.selected.file.metadata.yml.title": "Metadata (.metadata.yml)",
	"label.gateway.bundle.selected.file.bundle.title": "Gateway Bundle (.install.bundle)",
	"label.gateway.bundle.selected.file.delete.bundle.title": "Delete Bundle (.delete.bundle)",
	"label.gateway.bundle.edit.help.title": "Gateway Bundles Help",
	"label.gateway.bundle.edit.help.0.desc": "A Gateway Bundle is a set of files generated by the Policy Plugin. It can be deployed to a proxy.",
	"label.gateway.bundle.edit.help.1.desc": "If the Gateway Bundle is reusable, it can be consumed by a Portal-published API:",
	"label.gateway.bundle.edit.help.1.0": "Portal creates an API policy template from the metadata.",
	"label.gateway.bundle.edit.help.1.1": "Associate the policy with an API.",
	"label.gateway.bundle.edit.help.1.2": "Deploy the Gateway Bundle to a proxy.",
	"label.gateway.bundle.edit.help.1.3": "Deploy the API to the proxy.",
	"label.gateway.bundle.edit.help.2.desc": "Note: The policy must be available on the proxy where the API is deployed.",
	"label.gateway.bundle.delete.confirmation.text": "The Gateway Bundle {bundleName} will be deleted. This action cannot be undone.",
	"label.gateway.bundle.deleted": "Bundle deleted.",
	"label.gateway.bundle.deployment.type": "Deployment type",
	"label.gateway.bundle.deployment.ondemand": "On Demand",
	"label.gateway.bundle.delete.button": "Delete Gateway Bundle",
	"label.gateway.bundle.apis.filter.no.results": "There are no api to match your criteria.",
	"label.gateway.bundle.apis.no.results": "You have no apis associated with this Gateway Bundle.",
	"label.gateway.bundle.apis.filter.by.name.placeholder": "API Name",
	"label.gateway.bundle.apis.filter.by.proxy.name.placeholder": "Proxy Name",
	"label.gateway.bundle.api.states.all": "All States",
	"label.gateway.bundle.api.states.enabled": "Enabled",
	"label.gateway.bundle.api.states.disabled": "Disabled",
	"label.gateway.bundle.api.states.deprecated": "Deprecated",
	"label.gateway.bundle.api.states.unpublished": "Unpublished",
	"label.gateway.bundle.list.page.type.by.all.bundle.types": "All",
	"label.gateway.bundle.list.page.type.by.any.bundle.types": "Any Bundle Types",
	"label.gateway.bundle.list.page.type.by.encapsulated.assertion": "Encapsulated Assertion",
	"label.gateway.bundle.list.page.type.by.environment": "Environment",
	"label.gateway.bundle.list.page.policy.template.by.any": "Policy Template: Any",
	"label.gateway.bundle.list.page.policy.template.by.true": "Policy Template: True",
	"label.gateway.bundle.list.page.policy.template.by.false": "Policy Template: False",
	"label.user.filter.no.results": "There are no Users to match your criteria.",
	"label.organizations": "Organizations",
	"label.organization(s)": "Organization(s)",
	"label.organization.list.page.title": "Organizations",
	"label.organization.list.add.button": "Add Organization",
	"label.organization.list.page.filter.by.name.placeholder": "Enter Org Name",
	"label.organization.name": "Organization Name",
	"label.organization.type": "Type",
	"label.organization.accountplan": "Account Plan",
	"label.organization.state": "State",
	"label.organization.list.error": "Unknown error occured",
	"label.organization.no.results": "You have no Organizations.",
	"label.organization.filter.no.results": "There are no Organizations to match your criteria.",
	"label.organization.list.page.filter.by.all.types": "All Organization Types",
	"label.organization.list.page.filter.by.publisher.types": "Publisher",
	"label.organization.list.page.filter.by.consumer.types": "Consumer",
	"label.organization.list.page.help.text.consumer": "Organization that can only consume APIs",
	"label.organization.list.page.help.text.publisher": "Organization that can publish and consume APIs ",
	"label.organization.form.page.organization.add": "Add Organization",
	"label.organization.form.page.organization.edit": "Edit Organization",
	"label.organization.form.page.organization.name": "Organization Name",
	"label.organization.form.page.organization.type": "Type",
	"label.organization.form.page.organization.account.plan": "Account Plan",
	"label.organization.form.page.organization.public.description": "Public Description",
	"label.organization.form.page.place.holder.text": "Please select an Account Plan",
	"label.organization.form.page.radio.group.option.publisher": "Publisher",
	"label.organization.form.page.radio.group.option.publisher.description": "Organization that can have Org Publishers and be the managing organization of APIs.",
	"label.organization.form.page.radio.group.option.consumer": "Consumer",
	"label.organization.form.page.radio.group.option.consumer.description": "Organization that has users who can view and consume APIs.",
	"label.organization.form.page.helper.text.name": "Maximum name length is 255 characters. Name must be unique.",
	"label.organization.form.page.helper.text.description": "Maximum description length is 255 characters.",
	"label.organization.form.page.side.help.1": "You can add a new organization or edit an existing organization on this page. Organizations must be either one of the following organization types:",
	"label.organization.form.page.side.help.1.0": "Publisher: Allows managing APIs, publishing APIs, and proxy mappings.",
	"label.organization.form.page.side.help.1.1": "Consumer: Allows only consuming APIs.",
	"label.organization.form.page.side.help.2": "You can edit an Organization and change the Organization Type from Publisher to Consumer only after you remove all the following associations with the Publisher organization:",
	"label.organization.form.page.side.help.2.0": "Remove all Org Publishers from the organization",
	"label.organization.form.page.side.help.2.1": "Remove all managed APIs from the organization",
	"label.organization.form.page.side.help.2.2": "Remove all proxy mappings from the organization",
	"label.organization.form.page.side.help.3": "Note: Changing the organization type will supersede user permissions.",
	"label.organization.form.page.side.help.4": "Select the Account Plan from the drop-down menu and add a description. Click Create.",
	"label.organization.created.message": "Organization created.",
	"label.organization.updated.message": "Organization updated.",
	"label.user.list.page.title": "Users",
	"label.user.add.button": "Add User",
	"label.user.list.page.filter.by.name.placeholder": "Name",
	"label.user.list.page.filter.by.email.placeholder": "Email",
	"label.user.list.page.organization.by.all.organizations": "All Organizations",
	"label.user.list.page.role.by.all.roles": "All Roles",
	"label.user.role.portaladministrators": "Admin",
	"label.user.role.apiowners": "API Owner",
	"label.user.role.devorgadministrators": "Organization Admin",
	"label.user.role.orgpublishers": "Organization Publisher",
	"label.user.role.developers": "Developer",
	"label.user.list.page.status.by.all.statuses": "All Statuses",
	"label.user.status.enabled": "Enabled",
	"label.user.status.disabled": "Disabled",
	"label.user.status.locked": "Locked",
	"label.user.status.registration.init": "Pending Activation",
	"label.user.status.registration.pending.approval": "Pending Approval",
	"label.user.deleted": "User Deleted.",
	"label.user.no.name": "(no name given)",
	"label.api.name": "API Name",
	"label.api.tags": "Tags",
	"label.api.version": "Version",
	"label.api.deployed.proxies": "Deployed Proxies",
	"label.api.date.modified": "Date Modified ({zone})",
	"label.api.date.last.deployed": "Last Deployed ({zone})",
	"label.api.state": "State",
	"label.api.publish.source": "Publish Source",
	"label.api.deployed.status": "Deployment Status",
	"label.api.tags.available": "Available Tags",
	"label.api.tags.selected": "Selected Tags",
	"label.api.location": "Location of API",
	"label.api.location.help": "Requests to the API are forwarded to this hosted location. Maximum length is 255 characters.",
	"label.api.proxyUrl": "API URI",
	"label.api.proxyUrl.default": "[API Proxy URL] /",
	"label.api.proxyUrl.help": "Enter the relative URI to the API for applications to access. The URI must be unique and have a maximum length of 127 characters.",
	"label.apis.filter.no.results": "There are no api to match your criteria.",
	"label.apis.states.all": "All States",
	"label.apis.states.enabled": "Enabled",
	"label.apis.states.disabled": "Disabled",
	"label.apis.states.deprecated": "Deprecated",
	"label.apis.states.unpublished": "Unpublished",
	"label.apis.states.deleted": "Deleted",
	"label.apis.states.incomplete": "Incomplete",
	"label.apis.states.pending.bundle": "Pending Bundle",
	"label.apis.states.pending.delete": "Pending Delete",
	"label.apis.publish.source.all": "All Publish Sources",
	"label.apis.publish.source.portal": "Portal",
	"label.apis.publish.source.gateway": "Gateway",
	"label.apis.page.sort.by.last.deployed.asc": "Last Deployed: Old to New",
	"label.apis.page.sort.by.last.deployed.desc": "Last Deployed: New to Old",
	"label.api.keys.name": "Key Name",
	"label.api.keys.client.id": "Client ID",
	"label.api.keys.api.key": "API Key",
	"label.api.keys.status": "Key Status",
	"label.api.keys.deployment.status": "Key Deployment Status",
	"label.api.keys.application.name": "Application Name",
	"label.api.keys.last.deployed": "Last Deployed ({zone})",
	"label.api.keys.key.name.placeholder": "Key Name",
	"label.api.keys.api.key.placeholder": "API Key (Exact Match Only)",
	"label.api.keys.client.id.placeholder": "Client ID (Exact Match Only)",
	"label.api.keys.application.name.placeholder": "Application Name",
	"label.apis.key.status.any": "Any Status",
	"label.api.keys.list.no.results": "No results found",
	"label.api.keys.client.id.list.no.results": "Cliend ID search can only be an exact match. Enter full Client ID.",
	"label.api.keys.api.key.list.no.results": "API Key search can only be an exact match. Enter full API key.",
	"label.application.add": "Add Application",
	"label.application.edit": "Edit Application",
	"label.application.delete": "Delete Application",
	"label.application.apis.selected.api.plan": "API Plan: ",
	"label.application.apis.selected.api.plan.placeholder": "Please Select",
	"label.application.apis.selected.empty": "Add APIs and API groups to your application from the Available APIs/Available API Groups lists, below.",
	"label.application.create.assist.text": "You will receive an API key right away.",
	"label.application.create.select.hashing": "Create & Get Key",
	"label.application.create.after.approval.assist.text": "You will receive an API key right away. The app will work after it is approved.",
	"label.application.create.after.approval.select.hashing": "Submit & Get Key",
	"label.application.create.success": "Application created.",
	"label.application.update.success": "Application updated.",
	"label.application.request.submit": "Submit Request",
	"label.application.request.submit.success": "Application request submitted.",
	"label.application.key.state.enabled": "Enabled",
	"label.application.key.state.disabled": "Disabled",
	"label.application.key": "API Key (Client ID)",
	"label.application.key.name": "Key Name",
	"label.application.key.name.help": "The key name must be unique to this application. Maximum length is 255 characters.",
	"label.application.key.default": "Default Key",
	"label.application.key.default.help": "You can specify only one API key as the default key for the application. Applications require a default key.",
	"label.application.key.oauth.callback.url": "Callback/Redirect URL(s)",
	"label.application.key.oauth.callback.url.help": "Use commas to separate entries. Maximum length is 2048 characters.",
	"label.application.key.oauth.scope": "Scope",
	"label.application.key.oauth.scope.help": "Use spaces to separate entries. Maximum length is 4000 characters (450 characters for OTK versions older than 4.4).",
	"label.application.key.shared.secret": "Shared Secret (Client Secret)",
	"label.application.key.shared.secret.request": "Request",
	"label.application.key.shared.secret.generate.new": "Generate New Secret",
	"label.application.key.shared.secret.request.new": "Request New Secret",
	"label.application.key.shared.secret.plain": "Plaintext Secret",
	"label.application.key.shared.secret.hashed": "Hashed Secret",
	"label.application.key.shared.secret.hashed.generated.help": "Copy this shared secret. It will not be shown again.",
	"label.application.key.shared.secret.generated.info.1": "The newly generated secret is saved when you save the changes to the API key.",
	"label.application.key.shared.secret.generated.info.2": "The old secret is no longer valid. Share the new secret with the developers coding for this application.",
	"label.application.key.deployment.tooltip.title": "Key Deployment Types",
	"label.application.key.deployment.tooltip.subtitle": "Tip! You can change the type in the proxy settings.",
	"label.application.key.deployment.automatic.tooltip.title": "Automatic",
	"label.application.key.deployment.automatic.tooltip.subtitle": "API Portal automatically deploys the API key to all proxies.",
	"label.application.key.deployment.on.demand.tooltip.title": "On Demand",
	"label.application.key.deployment.on.demand.tooltip.subtitle": "The Portal Admin and users with deployment permissions manage the API key deployment to proxies as needed.",
	"label.application.key.create.success": "Key created.",
	"label.application.key.update.success": "Key updated.",
	"label.application.key.delete.success": "Key deleted.",
	"label.application.delete.confirmation.text": "Are you sure you want to delete the application?",
	"label.application.deleting": "Deleting Application",
	"label.application.deleting.status.text": "Undeploying keys and deleting application. This may take several minutes.",
	"label.proxy.details.page.title": "Proxy Details",
	"label.proxy.details.page.status.pending.enrollment": "Pending Enrollment",
	"label.proxy.details.page.overview.title": "Overview",
	"label.proxy.details.page.overview.gateway.version": "Gateway Version",
	"label.proxy.details.page.overview.otk.version": "OTK Version",
	"label.proxy.details.page.overview.proxy.url": "Proxy URL",
	"label.proxy.details.page.overview.organizations": "Organizations",
	"label.proxy.details.page.apis.deployments.title": "API Deployments",
	"label.proxy.details.page.application.api.keys.deployments.title": "API Key Deployments",
	"label.proxy.details.page.select.organization": "Select Organization",
	"label.proxy.details.page.overview.portal.compatibility": "Portal Compatibility",
	"label.proxy.details.page.overview.portal.compatibility.tooltip": "The API Proxy is compatible with the currently installed version of the API Portal, provided the latest Portal Integration Bundle is installed on the proxy after a Portal upgrade.",
	"label.proxy.details.page.overview.portal.incompatibility.tooltip": "The installed Portal Integration Bundle is outdated and requires updating in order for you to optimize API and API Key deployments and continue using all of the Portal's available features. To learn how to update the Portal Integration Bundle, see the 'Integration On-Premise API Proxies' topic in the API Developer Portal documentation.",
	"label.proxy.details.page.overview.portal.compatible": "Up to date",
	"label.proxy.details.page.overview.portal.incompatible": "Update required",
	"label.proxy.details.page.overview.deployment.type": "Deployment Type",
	"label.proxy.details.page.overview.deployment.type.automatic": "Automatic",
	"label.proxy.details.page.overview.deployment.type.on.demand": "On Demand",
	"label.proxy.details.page.overview.deployment.type.scripted": "Scripted",
	"label.proxy.details.page.overview.api.plans": "API Plans",
	"label.proxy.details.page.overview.account.plans": "Account Plans",
	"label.proxy.details.page.source": "Source",
	"label.proxy.details.page.status.published": "Published",
	"label.proxy.details.page.status.all.keys": "All Keys",
	"label.proxy.details.page.status.not.deployed": "Not Deployed",
	"label.proxy.details.page.status.pending": "Pending",
	"label.proxy.details.page.status.deployed": "Deployed",
	"label.proxy.details.page.status.error": "Error",
	"label.proxy.details.page.status.api.key.store": "API Key Store",
	"label.proxy.details.page.status.connected": "Connected",
	"label.proxy.details.page.status.disconnected": "Disconnected",
	"label.proxy.details.proxy.url.copied": "Proxy URL was copied to the clipboard.",
	"label.proxy.details.api.deployment.automatic.tooltip": "Published count is the number of APIs added to API Portal.",
	"label.proxy.details.api.deployment.on.demand.tooltip": "Gateway Published APIs cannot be deployed to On Demand proxies. Published count is the number of APIs added to API Portal.",
	"label.proxy.details.api.newsync": "new sync",
	"label.proxy.details.api.last.deployed": "Last deployed",
	"label.proxy.details.api.total": "Total",
	"label.proxy.details.api.portal": "Portal",
	"label.proxy.details.api.portal.published": "Portal Published",
	"label.proxy.details.api.gateway": "Gateway",
	"label.proxy.details.api.gateway.published": "Gateway Published",
	"label.proxy.details.api.hide.subtotal": "Hide Subtotal",
	"label.proxy.details.api.show.subtotal": "Show Subtotal",
	"label.proxy.details.portal.gateway.counts.different": "Portal & Gateway have different counts.",
	"label.proxy.details.api.proxy": "reporting on Proxy",
	"label.proxy.details.api.title.helptext": "Improved automatic sync running asynchronously.",
	"label.proxy.details.api.card.helptext": "APIs published to the proxy.",
	"label.proxy.details.api.old.card.helptext": "APIs added to the portal.",
	"label.proxy.details.api.key.deployment.tooltip": "All Keys count is the number of API Keys generated within the Applications in API Portal. API Key Store count is the number of API keys synched to the key store.",
	"label.proxy.details.edit.button": "Edit Proxy",
	"label.proxy.details.delete.button": "Delete Proxy",
	"label.proxy.details.delete.confirmation.text": "The Proxy will be deleted. This action cannot be undone.",
	"label.proxy.details.pending.enrollment.title": "Complete Proxy Enrollment",
	"label.proxy.details.pending.enrollment.copy.url.title": "1. Copy URL to Policy Manager",
	"label.proxy.details.pending.enrollment.enrollment.url": "Enrollment URL",
	"label.proxy.details.pending.enrollment.enrollment.url.copied": "Enrollment URL was copied to the clipboard.",
	"label.proxy.details.pending.enrollment.expires.text": "Expires in 24 hrs.",
	"label.proxy.details.pending.enrollment.confirm.enrollment.title": "2. Confirm Enrollment",
	"label.proxy.details.pending.enrollment.post.enrollment.note": "Return to this page to confirm that the proxy has been enrolled via Policy Manager.",
	"label.proxy.details.pending.enrollment.check.status": "Check Status",
	"label.proxy.details.pending.enrollment.checking": "Checking...",
	"label.proxy.details.info.switch.newSync": "This proxy is using a legacy automatic API deployment sync and will be deprecated. Switch over to the new automatic sync to optimize your API deployments.",
	"label.proxy.details.info.switch.linkText": "Switch to new sync",
	"label.proxy.details.apis.no.results": "You have no apis associated with this Proxy.",
	"label.proxy.details.tab.error.copied": "Error copied"
};


//////////////////
// WEBPACK FOOTER
// ./src/labels/messages_en.json
// module id = 1254
// module chunks = 0